<div [class.login-page]="!isLoggedIn">
  @if (isLoggedIn) {
    <app-topnav></app-topnav>
  }
  @if (!isLoggedIn) {
    <app-top-nav-login [bbApp]="true"></app-top-nav-login>
  }
  <div class="mb-10"></div>
  <div class="container">
    <div class="content">
      <div class="word-content">
        <span class="page-title">TERMS OF USE - CMHA BOUNCEBACK® PROGRAM</span>
        <ol>
          <li>
            <span class="title">Definitions</span>
            <p>
              “Personal information” means information about an identifiable individual (e.g., name, age, date of birth, home address,
              e-mail address, phone number, social insurance number, marital status, ethnicity, income, medical and health
              information, education, employment information, banking information, credit card information, and emergency contact
              information).
              <br><br>
              “Business contact information” means information that includes name, position name or title, business telephone number,
              business address, business email or business fax number that was collected, used, or disclosed for the purpose of
              communicating or facilitating communication with an individual in relation to their employment, business or profession.
              Business contact information is only subject to this Policy to the extent required under applicable privacy laws outside
              of British Columbia.
              <br><br>
              “Individual” includes clients (any individual receiving services or products from CMHA BC), participants, customers,
              members, volunteers, employees, and donors.
            </p>
          </li>

          <li>
            <span class="title">Collecting Personal Information</span>
            <p>
              Unless the purposes for collecting personal information are obvious and the individual voluntarily provides their
              personal information for those purposes, we will communicate the purposes for which personal information is being
              collected, either orally or in writing, before or at the time of collection. Subject to certain exceptions outlined
              herein, we will collect information directly from the individual.
              <br><br>
              We will only collect personal information that is necessary to fulfill the following purposes:
            </p>
            <ul>
              <li>To verify identity;</li>
              <li>To identify client preferences;</li>
              <li>To understand the needs of our clients;</li>
              <li>To enrol the client in a program or service;</li>
              <li>To ensure a high standard of service to our clients;</li>
              <li>To issue tax receipts;</li>
              <li>To contact and thank volunteers and supporters;</li>
              <li>To screen job applicants and to hire employees;</li>
              <li>To organize employee payroll;</li>
              <li>To screen volunteers;</li>
              <li>To schedule volunteer activities;</li>
              <li>To deliver services;</li>
              <li>To award education bursaries;</li>
              <li>To elect Board Members;</li>
              <li>To keep members informed and up to date on our activities, special events and opportunities;</li>
              <li>To register individuals for workshops and conferences;</li>
              <li>To meet regulatory requirements.</li>
            </ul>
          </li>

          <li>
            <span class="title">Consent</span>
            <p>
              We will obtain individual consent to collect, use or disclose personal information (except where, as noted below, we are
              authorized to do so without consent).
              <br><br>
              Where possible we will collect personal information directly from the individual. In cases where consent for collection
              is required, we may collect an individual's personal information from another source with the individual's consent. For
              example, we may collect certain information you have shared with, or receive de-identified data that is generated by,
              the third party hosting the BounceBack® program website in order to better deliver that program to you.
              <br><br>
              Consent can be provided orally, in writing, electronically, through an authorized representative or it can be implied
              where the purpose for collecting using or disclosing the personal information would be considered obvious and the
              individual voluntarily provides personal information for that purpose.
              <br><br>
              Subject to certain exceptions (e.g., the personal information is necessary to provide the service or product, or the
              withdrawal of consent would frustrate the performance of a legal obligation), individuals can withhold or withdraw their
              consent for CMHA BC to use their personal information in certain ways. An individual's decision to withhold or withdraw
              their consent to certain uses of personal information may restrict our ability to provide a particular service or
              product. If so, we will explain the situation to assist the individual in making the decision.
              <br><br>
              We may collect, use or disclose personal information without the individual's knowledge or consent as permitted by
              applicable law, including but not limited to the following circumstances (to the extent allowed by applicable law):
            </p>
            <ul>
              <li>When the collection, use or disclosure of personal information is permitted or required by law;</li>
              <li>In an emergency that threatens an individual's life, health, or personal security;</li>
              <li>When a reasonable person would consider that it is clearly in the interests of the individual and consent cannot be obtained in a timely way;</li>
              <li>When the personal information is available from a public source;</li>
              <li>When the information is used to decide whether an individual is suitable for an honour, award or other similar benefit including scholarships or bursaries;</li>
              <li>When we require legal advice from a lawyer;</li>
              <li>For the purposes of collecting or paying a debt;</li>
              <li>To protect ourselves from fraud;</li>
              <li>To investigate an anticipated breach of an agreement or a contravention of law;</li>
              <li>When another Act or regulation requires or allows for the collection of information without consent (e.g. collecting an employee’s social insurance number as required by the Income Tax Act to issue a T-4 slip);</li>
              <li>Where the information is necessary to collect or pay a debt owed to or by CMHA BC;</li>
              <li>Where consent is not required for disclosure (e.g., the disclosure is for the purpose of complying with a subpoena, warrant or order issued or made by a court; the disclosure is to law enforcement to assist in an investigation);</li>
              <li>To contact next of kin or a friend of an injured, ill or deceased individual;</li>
              <li>For employment purposes;</li>
              <li>For research or statistical purposes in certain circumstances;</li>
              <li>When we collect/use/disclose information from on or behalf of another organization (to which the individual previously gave consent), as long it’s for the purpose for which it was originally collected and is to assist us in carrying out our work on behalf of that organization.</li>
            </ul>
          </li>

          <li>
            <span class="title"> Using and Disclosing Personal Information</span>
            <p>
              We will only use or disclose personal information where necessary to fulfill the purposes identified at the time of
              collection, or for purposes allowed by applicable laws, or for a purpose reasonably related to those purposes such as:
            </p>
            <ul>
              <li>To conduct surveys in order to enhance the provision of our services; and</li>
              <li>To contact our clients directly about products and services that may be of interest.</li>
            </ul>
            <p>
              We will not use or disclose personal information for any additional purpose unless we obtain consent to do so.
              <br><br>
              We will not sell, rent or trade client lists or personal information to other parties.
              <br><br>
              When CMHA BC provides information to research bodies performing studies on mental health populations, the data is in
              aggregate form and not personally-identifying, so individuals remain anonymous. Any disclosure of information is
              compliant with applicable laws.
            </p>
          </li>

          <li>
            <span class="title">Retaining Personal Information</span>
            <p>
              If we use individual personal information to make a decision that directly affects the individual, we will retain that
              personal information for at least one year so that the individual has a reasonable opportunity to request access to it.
              <br><br>
              Subject to the one-year retention requirement, we will retain personal information only as long as necessary to fulfill
              the identified purposes or a legal or business purpose.
            </p>
          </li>

          <li>
            <span class="title">Ensuring Accuracy of Personal Information</span>
            <p>
              We will make reasonable efforts to ensure that personal information is accurate and complete where it may be used to
              make a decision about the individual or disclosed to another organization.
              <br><br>
              Individuals may request correction to their personal information in order to ensure its accuracy and completeness. A
              request to correct personal information must be made in writing and provide sufficient detail to identify the personal
              information and the correction being sought.
              <br><br>
              If the personal information is demonstrated to be inaccurate or incomplete, we will correct the information as required
              and send the corrected information to any organization to which we disclosed the personal information in the previous
              year. If the correction is not made, we will note the individual’s correction request in the file.
            </p>
          </li>

          <li>
            <span class="title">Securing Personal Information</span>
            <p>
              We are committed to ensuring the security of personal information in order to protect it from unauthorized access,
              collection, use, disclosure, copying, modification or disposal or similar risks.
              <br><br>
              The following security measures will be followed to ensure that personal information is appropriately protected.
            </p>
            <ol>
              <li>
                Physical Safeguards
                <ul>
                  <li>Personal information will be stored in locked filing cabinets.</li>
                  <li>Employee access to storage areas or filing cabinets will be restricted.</li>
                  <li>Files and documents containing personal information will not be left on desks when unattended (e.g., overnight).</li>
                  <li>Offices where personal information is held will be physically secured (e.g. locking doors).</li>
                  <li>Files containing personal information will not be removed from the CMHA BC offices (e.g. employees will not take files containing personal information home to work on).</li>
                  <li>Where files containing personal information need to be transported (e.g. for an office move), a secure courier service should be used.</li>
                </ul>
              </li>

              <li>
                Administrative Safeguards:
                <ul>
                  <li>We will provide training so that all employees know about and understand this privacy policy and requirements arising under applicable laws for protecting personal information.</li>
                  <li>All employees will read and sign CMHA BC’s confidentiality agreement regarding personal information.</li>
                  <li>Personal information, especially sensitive information, will only be accessible to those employees who need to know the information.</li>
                  <li>We will use role-based access to systems so that employees are only able to access personal information they need to perform their duties.</li>
                  <li>Employees will use cover sheets when faxing personal information and will establish and follow procedures for ensuring only the authorized recipient has received the fax.</li>
                </ul>
              </li>
              <li>
                Technical Safeguards:
                <ul>
                  <li>Employees will use password-protected computer screensavers so unauthorized personnel or visitors cannot see personal information.</li>
                  <li>We will protect our computers and network by using firewalls, intrusion detection software, antivirus software, and by encrypting personal information.</li>
                  <li>Employees will use strong and secure passwords as per the CMHA BC network logon password standards to make sure that only authorized employees have access to computer storage devices or to the network. Employees will be prompted to change these passwords on a regular basis.</li>
                  <li>Personal information stored on mobile electronic devices such as laptops and USB flash drives will be encrypted.</li>
                  <li>All mobile devices (e.g. laptops and mobile phones) containing personal information must lock automatically and must require a password to unlock.</li>
                  <li>Employees should not send personal information via e-mail. If personal information is received via e-mail, the receiver (employee) may respond but should de-identify the personal information, where possible (e.g. use client initials instead of their full name) and should not provide additional personal information. The receiver may also advise the sender (client or other employee) that email is not a secure method of communication.</li>
                  <li>We will securely wipe all personal information from hard drives before they are discarded, sold or donated.</li>
                  <li>Secure databases which contain personal information require password login and have timeout forced logout when idle.</li>
                  <li>We will use appropriate security measures when destroying individuals’ personal information such as shredding documents and deleting electronically stored information.</li>
                  <li>We will continually review and update our security policies and controls as technology changes to ensure ongoing personal information security.</li>
                </ul>
              </li>

            </ol>
          </li>

          <li>
            <span class="title">Providing Individuals Access to Personal Information</span>
            <p>Individuals have a right to access their personal information, subject to limited exceptions under applicable laws, which may include:</p>
            <ul>
              <li>Solicitor-client privilege</li>
              <li>Where the disclosure would reveal personal information about another individual</li>
              <li>Where there are health and safety concerns</li>
              <li>Where the disclosure would reveal confidential commercial information</li>
              <li>Where the disclosure would reveal the identity of an individual who provided information about another individual</li>
            </ul>
            <p>
              A request to access personal information must be made in writing and provide sufficient detail to identify the personal
              information being sought. A request to access personal information will be forwarded to the Privacy Officer for
              response.
              <br><br>
              Upon request, we will also tell individuals how we use their personal information and to whom it has been disclosed if
              applicable.
              <br><br>
              We will make the requested information available within 30 calendar days, or provide written notice of an extension
              where additional time is required to fulfill the request.
              <br><br>
              If permitted under applicable laws, a minimal fee may be charged for providing access to personal information. Where a
              fee may apply, we will inform the individual of the cost and request further direction from the individual on whether or
              not we should proceed with the request.
              <br><br>
              A fee will not be charged for an employee requesting their personal information.
              <br><br>
              If a request is refused in full or in part, we will notify the individual in writing, providing the reasons for refusal
              and the recourse available to the individual.
            </p>
          </li>

          <li>
            <span class="title">Contractors and Service Providers</span>
            <p>
              As outlined in the section 1.2 Scope, this policy applies to all contractors and service providers collecting, using or
              disclosing personal information on behalf of CMHA BC.
              <br><br>
              We may also work with third parties to deliver certain programs, for example, the BounceBack® program. These third
              parties may collect personal information directly from the individual, which collection will be subject to the privacy
              policies of that third party and not those of CMHA BC. Individuals should only provide their information if they agree
              with the third party's privacy policy.
              <br><br>
              In the event that we contract a third party to perform work for our organization, legally binding agreements exist that
              commit those organizations to strictly adhere to CMHA BC's privacy policy, PIPA and other applicable laws related to
              privacy. Contracts with service providers will include a Privacy Protection Schedule to protect information to standards
              no less strict than those outlined herein.
            </p>
          </li>

          <li>
            <span class="title">Roles and Responsibilities</span>
            <p>
              The protection of personal information is a responsibility shared by all.
              <br><br>
              All employees, including staff, management, and volunteers, are responsible for:
            </p>
            <ul>
              <li>Complying with this policy and applicable privacy laws;</li>
              <li>Participating in privacy training provided by CMHA BC;</li>
              <li>Requesting clarification where needed; and</li>
              <li>Reporting concerns, complaints, and requests for information to the Privacy Officer.</li>
            </ul>
            <p>Program Managers are responsible for:</p>
            <ul>
              <li> Ensuring compliance with this policy and applicable privacy laws in their program; and</li>
              <li> Responding to requests for information from clients in their program area and consulting with the Privacy Officer for
              guidance in responding.</li>
            </ul>
            <p>The Privacy Officer is responsible for:</p>
            <ul>
              <li>Ensuring CMHA BC's compliance with this policy, PIPA, and other applicable privacy laws;</li>
              <li>Advising employees on specific questions relating to the release of information and privacy;</li>
              <li>Reviewing and updating this policy regularly, or as applicable privacy laws are amended from time to time;</li>
              <li>Providing training and education to all employees;</li>
              <li>Supporting Branches in the implementation of privacy policies;</li>
              <li>Responding to complaints; and</li>
              <li>Liaising with the Office of the Information Privacy Commissioner for BC, where appropriate.</li>
            </ul>
            <p>Directors and the CEO are responsible for:</p>
            <ul>
              <li>Providing the time and resources for employees to attend training;</li>
              <li>Supporting employees in implementing this policy in their program or area.</li>
            </ul>
            <p>&nbsp;</p>
          </li>

          <li>
            <span class="title">Complaints and Requests for Information</span>
            <p>
              At CMHA BC, we are committed to having an accessible and responsive complaint-handling process in place to ensure
              individuals are able to make complaints about our organization's compliance with applicable privacy laws.
              <br><br>
              Individuals should direct any complaints, concerns or questions regarding CMHA BC's compliance in writing to the Privacy
              Officer. If the Privacy Officer is unable to resolve the concern, the individual may also write to the Information and
              Privacy Commissioner of British Columbia.
            </p>

            <p>
              <u>Privacy Officer Contact Information:</u><br><br>
              Privacy Officer <br><br>
              <span class="contact-cmha">
                <span>Canadian Mental Health Association, BC Division Suite 905 - 1130 West</span>
                <span>Pender Street Vancouver, BC V6E 4A4 Canada</span>
                <span>PrivacyOfficer&#x40;cmha.bc.ca</span>
              </span>
              <br><br>
              If a complaint or request for information is made to CMHA BC, the following actions take place:
            </p>
            <ol type="1">
              <li>The date of the complaint or request for information is recorded and the receipt is immediately acknowledged in writing. The Privacy Officer is notified by the employee who received the complaint or request.</li>
              <li>If necessary, the individual is contacted to clarify the nature of the complaint or request.</li>
              <li>If it is a complaint, the Privacy Officer investigates, fairly and impartially. The individual is notified of the outcome of the investigation clearly and promptly, and informed of any relevant steps taken to address their complaint. The complainant receives a response within 30 business days.</li>
              <li>If it is a request for information, the Program Manager may respond in consultation with the Privacy Officer. The requester receives a response within 30 business days.</li>
              <li>Where applicable, inaccurate personal information is corrected and policies and procedures may be modified based on the outcome of the complaint.</li>
              <li>The date responded and outcome are recorded by the Privacy Officer.</li>
              <li>All complaints received by the Privacy Officer will be included in an annual report made by the CEO to CMHA BC’s Board of Directors.</li>
            </ol>
            <p>
              If we are not able to resolve your concern, the individual may contact the Office of the Information and Privacy Commissioner for British Columbia:
              <span class="contact-cmha">
                <span>PO Box 9038 Stn. Prov. Govt. Victoria, BC V8W 9A4</span>
                <span>1-800-663-1376</span>
                <span><a href='mailto:info@oipc.bc.ca'>info&#x40;oipc.bc.ca</a></span>
                <span><a href = 'https://www.oipc.bc.ca'>www.oipc.bc.ca</a></span>
              </span>
            </p>
          </li>

          <li>
            <span class="title"> Links</span>
            <p>
              Legislation:<a href="https://www.bclaws.gov.bc.ca/civix/document/id/complete/statreg/00_03063_01">
              Personal Information Protection Act (PIPA)
            </a><br><br>
            <a href="https://www.oipc.bc.ca/tools-guidance/guidance-documents.aspx" >
              A Guide to PIPA for Businesses and Organizations.
            </a>
            (2012) Office of the Information Privacy Commissioner for British Columbia.<br><br>
            <u>Privacy Helpline</u><br><br>
            <span class="contact-cmha">
              <span>The OCIO also operates a Privacy Helpline, providing support, direction and training to private sector organizations and
              the public on PIPA’s requirements.</span>
              <span>Phone: 250-356-1851</span>
              <span>Email: <a href="mailto:Privacy.Helpline@gov.bc.ca">Privacy.Helpline&#x40;gov.bc.ca</a></span>
            </span>
          </p>
        </li>
      </ol>
    </div>
  </div>
</div>
@if (isLoggedIn) {
  <app-footer></app-footer>
}
@if (!isLoggedIn) {
  <app-footer [bbapp]="true" [showLogos]="true" [showBrandImage]="false"></app-footer>
}
</div>